import appKeyActionTypes from "./appKeyActionTypes";

const initialState = {
  keys: {},
  baseUrl: "",
  accountDefaultLang: { defaultLanguage: "", langs: [], country: "" },
  generalConfig: {},
  error: null,
  userRights: {},
  userActiveLanguages: [],
  sessionKeyUser: {},
  fieldPermissions: null,
  franchiseUser: null,
};

const appKeyReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case appKeyActionTypes.SAVE_KEY:
      return {
        ...state,
        keys: payload,
      };

    case appKeyActionTypes.SAVE_BASE_URL:
      return {
        ...state,
        baseUrl: payload,
      };

    case appKeyActionTypes.SAVE_ACCOUNT_LANG:
      return {
        ...state,
        accountDefaultLang: {
          defaultLanguage: payload.pageLang || payload.default_language,
          langs: payload.langs.split(","),
          country: payload.country,
        },
        generalConfig: payload,
      };

    case appKeyActionTypes.GET_USER_RIGHTS_SUCCESS:
      return {
        ...state,
        userRights: payload,
      };

    case appKeyActionTypes.GET_USER_LANG_SUCCESS:
      return {
        ...state,
        userActiveLanguages: payload,
      };

    case appKeyActionTypes.GET_SESSION_USER_SUCCESS:
      return {
        ...state,
        sessionKeyUser: payload,
      };

    case appKeyActionTypes.GET_SESSION_USER_FAILED:
      return {
        ...state,
        sessionKeyUser: {},
      };

    case appKeyActionTypes.GET_FIELD_PERMISSIONS_SUCCESS:
      return {
        ...state,
        fieldPermissions: payload,
      };

    case appKeyActionTypes.GET_FRANCHAISE_SUCCESS:
      return {
        ...state,
        franchiseUser: payload,
      };

    case appKeyActionTypes.GET_FRANCHAISE_FAILED:
      return {
        ...state,
        franchiseUser: null,
      };

    case appKeyActionTypes.GET_FIELD_PERMISSIONS_FAILED:
      return {
        ...state,
        fieldPermissions: null,
      };

    case appKeyActionTypes.GET_USER_LANG_FAILED:
      return {
        ...state,
        userActiveLanguages: [],
      };

    case appKeyActionTypes.GET_USER_RIGHTS_FAILED:
      return {
        ...state,
        userRights: {},
      };

    case appKeyActionTypes.GET_ACCOUNT_CONFIG_FAILED:
      return {
        ...state,
        error: payload,
      };

    default:
      return state;
  }
};

export default appKeyReducer;
